import { useState } from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

const fecha = (s) => (s ? s.slice(0, 10).split("-").reverse().join("/") : "");

function Resultado({ r }) {
  const g = r.geometria;
  return <ul className="mt-2 space-y-1 text-xs" data-testid="verificar-snc-resultado">
    <li data-testid="verificar-snc-titular">{r.titular.igual ? "✔ El titular sigue siendo el mismo" : <>⚠ <b>Cambió el titular</b>: antes {r.titular.antes.join(", ") || "—"} · ahora {r.titular.ahora.join(", ") || "—"}</>}</li>
    <li data-testid="verificar-snc-geometria">{g.encuadra == null ? "· Contorno: sin comparación" : g.encuadra ? `✔ El contorno encuadra con el guardado (${g.diferencia_pct}% de diferencia)`
      : <>⚠ <b>El contorno cambió</b> ({g.diferencia_pct}% de diferencia) · se guardó el nuevo</>}</li>
    <li data-testid="verificar-snc-gravamen">{r.gravamen.nuevos ? <>⚠ <b>{r.gravamen.nuevos} expediente(s) nuevo(s)</b> en el SNC</> : "✔ Sin expedientes nuevos"}
      {r.gravamen.activos.length ? ` · gravámenes activos: ${r.gravamen.activos.join(", ")}` : " · sin gravámenes activos"}</li>
  </ul>;
}

export function VerificarSnc({ cod, padron, verificado, onOk }) {
  const [c, setC] = useState(false);
  const [r, setR] = useState(null);
  const ir = () => {
    setC(true);
    api.post("/portal/titulares/parcela/verificar-snc", null, { params: { cod, padron }, timeout: 70000 })
      .then((x) => { setR(x.data); onOk?.(); })
      .catch((x) => toast.error(formatApiErrorDetail(x?.response?.data?.detail) || "El catastro no responde"))
      .finally(() => setC(false));
  };
  return <div className="rounded-lg border border-emerald-200 bg-emerald-50/60 px-3 py-2" data-testid="verificar-snc">
    <p className="text-xs text-slate-600">Datos memorizados en TierraScore{verificado ? ` · última verificación con el SNC: ${fecha(verificado)}` : ""}. Al abrir no se consulta al catastro.</p>
    <button onClick={ir} disabled={c} className="mt-1.5 inline-flex items-center gap-1.5 rounded-full bg-[#1f7a4d] text-white px-3 py-1.5 text-xs font-semibold disabled:opacity-60" data-testid="verificar-snc-btn">
      {c ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <ShieldCheck className="w-3.5 h-3.5" />}Consultar estado en Servicio Nacional de Catastro</button>
    {r && <Resultado r={r} />}
  </div>;
}
